import { render, staticRenderFns } from "./form-data.vue?vue&type=template&id=5fc8826f&scoped=true&"
import script from "./form-data.vue?vue&type=script&lang=js&"
export * from "./form-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8826f",
  null
  
)

export default component.exports